import { Collapse, TableCell, Typography } from "@mui/material";
import { ILocal } from "../../models/dashboard";

export interface DashboardCellProps{
    local : ILocal, 
    open : boolean
}

const COLORS = {
    green : "#e2efd9",
    orange : "#f7caac",
    red : "#ff7979",
}
const getColor = (time : number, minTime : number) => {
  return time === 0 ? COLORS.red :
         time > minTime ? COLORS.green : COLORS.orange;
}

const createEmployeeCell = (local : ILocal) => {
    let scans = local.scans.reduce((acc, scan) => {
        const time = acc.get(scan.username);
        time ? acc.set(scan.username, time + scan.time) : acc.set(scan.username,scan.time);
        return acc;
    }, new Map<string,number>());

    let usernames = Array.from(scans.keys());

    let cells = usernames.map((username) => 
        (<Typography className="sameline-typography" style={{display: 'inline-block'}}> {username} : {scans.get(username)?.toFixed(2)} min</Typography>)
    );

    return cells;
}
const DashboardCell = (props : DashboardCellProps) => {
    const {local , open} = props;
    const totalTime = local.scans.reduce((acc, employee) => acc + employee.time, 0);

    return (
        <TableCell align="center" style={{background : getColor(totalTime, local.minTime)}}>
            <Typography style={{ fontWeight: 'bold' }}> {local.id} - {local.name} </Typography>
            <Typography style={{ fontWeight: 'bold' }}> {totalTime < 1 ? totalTime : Math.round(totalTime)} minutes </Typography>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <br></br>
                {createEmployeeCell(local)}
            </Collapse>
        </TableCell>
    )
}

export default DashboardCell;
